<template>
  <div class="bg">
    <div class="Index" v-show="indexStatus">
      <div class="banner">
        <img src="../assets/image/banner.jpg" />
        <div class="theme">
          <div class="countdown">
            <div class="countdownLi">0</div>
            <p class="countdownText">天</p>
            <div class="countdownLi">{{ hours }}</div>
            <p class="countdownText">时</p>
            <div class="countdownLi">{{ minutes }}</div>
            <p class="countdownText">分</p>
            <div class="countdownLi">{{ seconds }}</div>
            <p class="countdownText">秒</p>
          </div>

          <input
            type="text"
            v-model="vipAccount"
            placeholder="请输入会员账号"
            v-if="!playGameStatus"
          />

          <div class="playGame" @click="robFunc">
            <img src="../assets/image/login_btn.png" alt />
          </div>

          <div class="playGame" @click="playGameFunc" v-if="playGameStatus">
            <p class="playGameNum">剩余抽奖次数：{{ prizeNum }}</p>

            <img src="../assets/image/playgame.png" @click="playGameFunc" alt />
          </div>
        </div>
      </div>

      <div class="notice">
        <div class="noticeT">
          <p>活动内容</p>
          <img src="../assets/image/notice_t.jpg" alt />
        </div>

        <div class="noticeM">
          <div class="redInfoT">
            <div class="redInfoTLi">红包金额</div>
            <div class="redInfoTLi">红包地址</div>
            <div class="redInfoTLi">抢红包时间</div>
          </div>

          <div class="redInfoC">
            <div class="redInfoCLi redInfo_1">
              <p>
                最低1元
                <br />最高 <span>88888</span>元
              </p>
            </div>
            <div class="redInfoCLi redInfo_2">
              <p>
                电脑手机均可
                <br />登入
                <span>yj9966hb.com</span>
                <br />即可进行抢红包
              </p>
            </div>
            <div class="redInfoCLi redInfo_3 redInfo_3_extra">
              <p>
                当天达到要求的会员请次日(北京时间12:00~23:59)开抢!(中奖后30分钟内自动派送)
              </p>
            </div>
          </div>

          <div class="read">
            <div class="readLi">
              只要达到活动要求,即可参与抢金币,好运就在一瞬间发生,单个最高可达88888元现金筹码。
            </div>
          </div>

          <div class="table" style="margin-top: 30px">
            <div class="thead">
              <div class="th">打码金额</div>
              <div class="th">获赠抢红包机会</div>
            </div>
            <template v-for="(item, index) in ruleList">
              <div class="tbody" :key="index">
                <div class="td">{{ sumMoney(item.recharge) }}</div>
                <div class="td">{{ item.count }}次</div>
              </div>
            </template>
          </div>
          <div class="read">
            <div class="readLi">
              注:会员必须达到指定的存款金额及有效投注才可以获得对应抢红包次数。若达到存款没有达到有效投注,则不计算抢红包次数!例如:会员当日存款50元+累计有效投注达到5万抢红包4次抢中红包:188元,888元,1888元,3888元,中奖后系统将于30分钟自动派送。
            </div>
          </div>
        </div>
        <img class="noticeB" src="../assets/image/notice_b.jpg" alt />
      </div>

      <div class="notice">
        <div class="noticeT">
          <p>活动说明</p>
          <img src="../assets/image/notice_t.jpg" alt />
        </div>
        <div class="noticeM">
          <div class="read">
            <div class="readLi">
              1.会员当日存款50元且累计投注达到500元以上即可获得抢红包机会;
            </div>
            <div class="readLi">2.所获红包金额一倍流水,即可申请提款;</div>
            <div class="readLi">
              3.会员投注均由系统自动统计,若有任何异议,以妖姬直播为准;
            </div>
            <div class="readLi">
              4.妖姬直播的所有优惠均是为玩家而设,同一账号,同一姓名,同一住址,同一IP,同一号码,同一银行卡账户均视为同一人,如发现任何团队或个人以不诚实的方式套取红利,威胁滥用公司优惠等行为,公司保留冻结并取消该团队或者个人账户及账户的结余权利;
            </div>
            <div class="readLi">
              5.妖姬直播保留对活动的最终解释权,以及再无通知的情况下修改或终止活动的权利,适用于所有优惠。
            </div>
          </div>
        </div>
        <img class="noticeB" src="../assets/image/notice_b.jpg" alt />
      </div>

      <img class="turn" src="../assets/image/turn.jpg" alt />

      <div class="redRain">
        <div class="redRainLiWidth"></div>
        <template v-for="(item, index) in redRainArray">
          <img
            class="redRainLi"
            :src="item.src"
            :style="{ top: item.top, left: item.left, transition: item.speed }"
            :key="index"
          />
        </template>
      </div>

      <div class="redOperate" v-if="redStatus">
        <!-- 打开红包弹窗 -->
        <div class="openred" v-if="openredStatus">
          <img src="../assets/image/openred.png" alt />

          <div class="openredArea" @click="toGetRedFunc"></div>

          <div class="closeredArea" @click="closeredFunc"></div>
        </div>
        <!-- 获奖弹窗 -->
        <div class="getred" v-show="getredStatus">
          <img src="../assets/image/getred.png" alt />
          <p>
            {{ winMoney }}
            <span>元</span>
          </p>
          <div class="getredArea" @click="getRedFunc"></div>

          <div class="closeGetRedArea" @click="closeGetredFunc"></div>
        </div>

        <!-- 失败弹窗 -->
        <div class="losered" v-if="loseredStatus">
          <img src="../assets/image/losered.png" alt />

          <div class="loseredArea" @click="loseredFunc"></div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <div class="register" v-if="registerStauts">
        <div class="registerTips">
          <img src="../assets/image/register.png" alt />

          <div class="registerYes" @click="registerFunc"></div>
          <div class="registerNo" @click="closeRegister"></div>
          <div class="registerClose" @click="closeRegister"></div>
        </div>
      </div>
    </div>

    <img
      v-if="playGameStatus"
      @click="logoutFunc"
      class="logout"
      src="../assets/image/logout.png"
      alt=""
    />
    <div class="recordPage" v-show="recordStatus">
      <div class="record">
        <div class="recordC" @scroll="handleScroll">
          <div class="recordScroll">
            <template v-for="(item, index) in recordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width: 25%">
                  {{ formatDateTime(item.receiveTime) }}
                </div>
                <div class="recordTd" style="width: 22%">
                  第{{ item.lotteryCount || 0 }}次
                </div>
                <div class="recordTd" style="width: 28%">
                  获得{{ item.rewardAmount }}红包
                </div>
                <div class="recordTd" style="width: 25%">
                  {{ item.dispatchStatusDesc }}
                </div>
              </div>
            </template>

            <div class="recordLiHeight"></div>
          </div>
        </div>
      </div>

      <div class="backArea" @click="back">&lt; 返回</div>

      <!-- <div class="turnArea"></div> -->
    </div>

    <div
      class="playGameRecord"
      @click="toRecord"
      v-if="playGameStatus && indexStatus"
    >
      <img src="../assets/image/red_record.png" alt />
    </div>
  </div>
</template>

<script>
import {
  getPacket,
  getHistory,
  getRemainCount,
  authLogin,
  getConfig,
  getRule,
  getLogout,
} from "@/api/red";

import { Message } from "element-ui";
import { getToken, setToken, removeToken } from "@/utils/request";
import redImg from "../assets/image/red.png";

const ACCOUNT_KEY = "yaoji_red_account";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      indexStatus: true,
      redTimer: null,
      redRainArray: [],
      registerStauts: false,
      playGameStatus: false,
      redStatus: false,
      openredStatus: false,
      getredStatus: false,
      loseredStatus: false,
      recordStatus: false,
      prizeNum: 0,
      winMoney: 0,
      step: 0,
      recordTimer: null,
      ruleList: [],
      recordList: [],
      vipAccount: "",
      registerUrl: "",
      hours: 0,
      minutes: 0,
      seconds: 0,

      isLoadingMore: false, // 是否正在加载更多
      recordNum: 1, // 当前页码
      hasMore: true, // 是否还有更多数据
      activityId: "",
    };
  },
  mounted() {
    setInterval(() => {
      this.hours = this.countdown().hours;
      this.minutes = this.countdown().minutes;
      this.seconds = this.countdown().seconds;
    }, 1000);
    // 规则
    getRule().then((res) => {
      this.ruleList = res.data;
    });

    // 配置地址
    getConfig({ appid: process.env.VUE_APP_APPID }).then((res) => {
      res.data.forEach((v) => {
        if (v.key == "registration_link") {
          this.registerUrl = v.value;
        }
      });
    });

    this.restoreLogin();
  },

  methods: {
    // 检测是否有登录状态
    restoreLogin() {
      const token = getToken();
      const account = localStorage.getItem(ACCOUNT_KEY);
      if (!token || !account) return;
      this.vipAccount = account;

      getRemainCount()
        .then((res) => {
          if (res.code !== 200) {
            removeToken();
            localStorage.removeItem(ACCOUNT_KEY);
            this.vipAccount = "";
            this.registerStauts = true;
            return;
          }

          localStorage.setItem(ACCOUNT_KEY, this.vipAccount);

          this.prizeNum = res.data.count;
          this.playGameStatus = true;
          this.activityId = res.data.activityId;
        })
        .catch(() => {
          removeToken();
          localStorage.removeItem(ACCOUNT_KEY);
          this.vipAccount = "";
        });
    },
    // 红包雨动画
    redRainFunc() {
      this.redRainArray = [];
      let owindow_width = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          owindow_width = document.documentElement.clientWidth;
        })();
      };

      let redWidth = document.querySelector(".redRainLiWidth").offsetWidth;

      clearInterval(this.redTimer);
      this.redTimer = setInterval(() => {
        let red1 = parseInt(Math.random() * (owindow_width - redWidth));
        let red2 = parseInt(Math.random() * redWidth * 2 + 1);
        let speed = parseInt(Math.random() * 3 + 10);

        this.redRainArray.push({
          src: redImg,
          left: red1 + "px",
          top: 0,
          speed: 0,
        });

        if (this.redRainArray[this.redRainArray.length - 2]) {
          this.redRainArray[this.redRainArray.length - 2] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
        }

        if (this.redRainArray.length > 25) {
          // this.redRainArray = []
          this.redRainArray[this.redRainArray.length - 1] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
          clearInterval(this.redTimer);
        }
      }, 200);

      // setTimeout(() => {
      //   this.redRainArray = []
      //   clearInterval(this.redTimer)
      // }, 5000)
    },
    // 抢红包
    robFunc() {
      if (!this.vipAccount) {
        Message({
          message: "请输入会员账号！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      // 进行登录
      authLogin({ accountName: this.vipAccount }).then((res) => {
        console.log(res);

        if (res.code !== 200) {
          this.registerStauts = true;
          this.loginStatus = true;
        } else {
          // 保存 token 到全局
          if (res.data && res.data.token) {
            setToken(res.data.token);
            console.log("Token 已保存:", res.data.token);
          }

          localStorage.setItem(ACCOUNT_KEY, this.vipAccount);

          // 获取红包次数
          getRemainCount().then((res) => {
            this.prizeNum = res.data.count;
            this.playGameStatus = true;

            this.activityId = res.data.activityId;
          });
        }
      });
    },
    // 开始游戏
    playGameFunc() {
      if (this.prizeNum == 0) {
        Message({
          message: "没有抽奖次数！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      this.redRainFunc();
      this.redStatus = true;
      this.openredStatus = true;
    },
    // 关闭拆红包界面
    closeredFunc() {
      this.redStatus = false;
      this.openredStatus = false;

      // 关掉红包雨
      this.redRainArray = [];
      clearInterval(this.redTimer);
    },
    // 关闭收红包界面
    closeGetredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 去拆完红包界面
    toGetRedFunc() {
      getPacket(this.activityId).then((res) => {
        // 判断是否中奖
        if (res.data.money == 0) {
          this.openredStatus = false;
          this.loseredStatus = true;
        } else {
          this.openredStatus = false;
          this.getredStatus = true;
          this.winMoney = res.data.money;
        }
        this.prizeNum = res.data.count;
      });
    },
    // 收下红包
    getRedFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 未中奖
    loseredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.loseredStatus = false;
    },
    // 跳转注册
    registerFunc() {
      window.open(this.registerUrl);
    },
    // 关闭注册
    closeRegister() {
      this.registerStauts = false;
    },
    // 跳转抽奖记录
    toRecord() {
      this.recordStatus = true;
      this.indexStatus = false;

      this.recordNum = 1;
      this.recordList = [];
      this.isLoadingMore = false;
      this.hasMore = true;
      this.historyRecord();
    },

    // 返回抽奖大厅
    back() {
      this.clearRecordTimer();

      this.recordStatus = false;
      this.indexStatus = true;
    },
    // 红包记录
    historyRecord() {
      if (this.isLoadingMore || !this.hasMore) return;
      this.isLoadingMore = true;

      getHistory({
        activityType: 6,
        pageNo: this.recordNum,
        pageSize: 10,
      }).then((res) => {
        this.recordList.push(...res.rows);
        this.recordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hasMore = res.rows.length === 10;
        this.isLoadingMore = false;
      });
    },
    // 红包记录滚动
    handleScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) {
        this.historyRecord();
      }
    },

    // 清除文字滚动
    clearRecordTimer() {
      clearInterval(this.recordTimer);
    },
    // 红包倒计时
    countdown() {
      const now = new Date();
      const nextDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
      );
      const difference = nextDay - now; // 计算时间差（毫秒）

      // 将时间差转换为时分秒格式
      const seconds = Math.floor((difference / 1000) % 60)
        .toString()
        .padStart(2, "0");

      const minutes = Math.floor((difference / 1000 / 60) % 60)
        .toString()
        .padStart(2, "0");
      const hours = Math.floor((difference / 1000 / 60 / 60) % 24)
        .toString()
        .padStart(2, "0");

      // 返回格式化的剩余时间
      return {
        hours,
        minutes,
        seconds,
      };
    },
    // 转化金额单位
    sumMoney(val) {
      let result = "";
      if (val < 10000) {
        result = val + "元+";
      } else {
        result = Math.floor(val / 10000) + "万+";
      }
      return result;
    },
    // 退出登录
    logoutFunc() {
      getLogout().then((res) => {
        Message({
          message: res.msg,
          type: "warning",
          duration: 5 * 1000,
        });
        removeToken();
      });

      localStorage.removeItem(ACCOUNT_KEY);
      this.vipAccount = "";
      this.playGameStatus = false;
    },
    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return "";

      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      // const hours = String(date.getHours()).padStart(2, "0");
      // const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bg {
  position: relative;
}
.Index {
  position: relative;
}

.banner {
  position: relative;
  img {
    width: 100%;
  }

  .theme {
    background: url("../assets/image/theme.png") no-repeat;
    background-size: 100% 100%;
    width: 1060px;
    height: 993px;
    position: absolute;
    transform: translate(-50%, 0);
    top: 660px;
    left: 50%;
    .countdown {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 18px;
      position: absolute;
      top: 885px;
      left: 50%;
      width: 422px;
      transform: translate(-50%, 0);
      margin-left: 39px;
      .countdownLi {
        color: #fff;
        font-size: 26px;
        background: #ac1a03;
        border-radius: 8px;
        padding: 9px 3px;
        min-width: 47px;
      }
      .countdownText {
        color: #fff;
        margin-top: -3px;
        font-size: 26px;
        line-height: 26px;
      }
    }
    input {
      position: absolute;
      top: 702px;
      left: 323px;
      background: none;
      border: 0;
      color: #ae1903;
      font-size: 40px;
      width: 441px;
      text-align: center;
      &::placeholder {
        color: #ae1903;
        font-size: 40px;
      }
    }
    input[type="text"]:focus {
      outline: none;
    }

    .rob {
      position: absolute;
      top: 682px;
      left: 610px;
      width: 87px;
      height: 87px;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  .playGame {
    position: absolute;
    top: 1020px;
    left: 191px;
    .playGameNum {
      width: 341px;
      height: 50px;
      line-height: 50px;
      margin-left: 197px;
      color: #ae1903;
      font-size: 40px;
      position: absolute;
      top: -321px;
      left: 0;
    }
    img {
      width: 762px;
      cursor: pointer;
      margin-left: -25px;
    }
  }
}

.notice {
  .noticeT {
    position: relative;
    img {
      width: 100%;
    }
    p {
      font-size: 60px;
      line-height: 60px;
      color: #fcf4c6;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-left: 14px;
    }
  }
  .noticeM {
    background: url("../assets/image/notice_m.jpg");
    background-size: contain;
    margin-top: -15px;
    min-height: 100px;
    padding-top: 35px;
    .read {
      text-align: left;
      padding: 0px 103px;
      .readLi {
        color: #e64a21;
        font-size: 35px;
      }
    }

    .redInfoT {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 870px;
      margin: 0 auto;
      .redInfoTLi {
        font-size: 35px;
        background: linear-gradient(180deg, #f96829, #f95242);
        color: #fff;
        width: 278px;
        height: 50px;
        border-radius: 25px;
      }
    }

    .redInfoC {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 870px;
      margin: 20px auto;
      .redInfoCLi {
        width: 278px;
        height: 373px;
        border-radius: 15px;
        p {
          color: #e82b15;
          margin-top: 15px;
          font-size: 24px;
          span {
            font-size: 36px;
          }
        }
      }
      .redInfo_1 {
        background: url("../assets/image/redInfo_1.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
      }
      .redInfo_2 {
        background: url("../assets/image/redInfo_2.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
      }
      .redInfo_3 {
        background: url("../assets/image/redInfo_3.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
      }
      .redInfo_3_extra {
        text-align: left;
        padding: 0px 15px;
        box-sizing: border-box;
        word-break: break-all;
      }
    }
  }
  .noticeB {
    width: 100%;
  }

  .table {
    border: 1px solid #e9331d;
    width: 871px;
    margin: 0 auto 15px;
    border-radius: 20px;
    .thead {
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      background: linear-gradient(180deg, #f96829, #f95242);
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      .th {
        flex: 1;
        flex-shrink: 0;
        color: #fff;
        font-size: 40px;
        border-right: 1px solid #fff;
        min-height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .th:last-child {
        border-right: 0;
      }
    }

    .tbody {
      display: flex;
      width: 100%;
      .td {
        flex: 1;
        flex-shrink: 0;
        color: #e92a17;
        font-size: 35px;
        border-right: 1px solid #b32316;
        border-bottom: 1px solid #b32316;
        min-height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .td:last-child {
        border-right: none;
      }
    }

    .tbody:last-child {
      .td {
        border-bottom: none;
      }
    }
  }
}

.turn {
  width: 100%;
}

.redRain {
  position: fixed;
  top: 0;
  left: 0;
  .redRainLi {
    position: absolute;
    width: 100px;
  }
  .redRainLiWidth {
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 100px;
  }
}

.redOperate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  .openred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 800px;
    }
    .openredArea {
      position: absolute;
      left: 157px;
      bottom: 42px;
      width: 473px;
      height: 139px;
      cursor: pointer;
    }
    .closeredArea {
      position: absolute;
      right: 111px;
      top: 0;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }
  .getred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 800px;
    }
    .getredArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetRedArea {
      position: absolute;
      right: 153px;
      top: 77px;
      width: 46px;
      height: 47px;
      cursor: pointer;
      border-radius: 25px;
    }

    p {
      font-size: 116px;
      position: absolute;
      left: 50%;
      bottom: 564px;
      transform: translate(-50%, 0);
      height: 116px;
      line-height: 116px;
      font-weight: bold;
      background: linear-gradient(180deg, #ff5401, #ff1300);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      span {
        position: absolute;
        right: -26px;
        bottom: 20px;
        font-size: 29px;
        line-height: 20px;
        display: block;
        color: #ff2900;
        background: none;
        -webkit-text-fill-color: #ff2900;
      }
    }
  }

  .losered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 600px;
    }
    .loseredArea {
      position: absolute;
      left: 106px;
      bottom: 274px;
      width: 386px;
      height: 93px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  .registerTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 800px;
    }
    .registerYes {
      position: absolute;
      left: 71px;
      bottom: 244px;
      width: 282px;
      height: 89px;
      cursor: pointer;
      border-radius: 25px;
    }
    .registerNo {
      position: absolute;
      left: 420px;
      bottom: 244px;
      width: 282px;
      height: 89px;
      cursor: pointer;
      border-radius: 25px;
    }
    .registerClose {
      position: absolute;
      left: 367px;
      bottom: 3px;
      width: 66px;
      height: 66px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.recordPage {
  background: url("../assets/image/record.jpg") no-repeat;
  background-size: contain;
  width: 1080px;
  height: 2842px;
  position: absolute;
  top: 0;
  left: 0;
  .record {
    position: absolute;
    top: 1900px;
    left: 84px;

    .recordC {
      width: 911px;
      height: 650px;
      overflow-y: auto;
      position: absolute;
      top: 0;
      left: 0;
      .recordScroll {
        width: 100%;
        .recordLi {
          display: flex;
          align-items: center;
          height: 65px;
          .recordTd {
            color: #d1233e;
            font-size: 30px;
            padding-bottom: 30px;
          }
        }
      }

      .recordLiHeight {
        position: fixed;
        top: -10000px;
        left: -10000px;
        height: 65px;
      }
    }
  }

  .backArea {
    position: fixed;
    top: 30px;
    left: 40px;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
  }

  .turnArea {
    position: absolute;
    bottom: 95px;
    left: 30px;
    width: 1020px;
    height: 75px;
    cursor: pointer;
  }
}

.playGameRecord {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  img {
    width: 72px;
  }
}

.marquee {
  position: relative;
  transition: top 0.2s linear;
}

.logout {
  position: absolute;
  right: 20px;
  top: 40px;
  width: 280px;
  height: 60px;
}
</style>
